import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../components/Loading";
import { getCurrentUser } from "../../../controller/users/usersController";
import { fetchStartupContents } from "../../../graphQL/controller/startupContentsController";
import { setActiveAuthSessionType } from "../../../utils/localStorage";
import { hasValidJwtSession } from "../utils/lmsSession";

const LmsProtectedRoute = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { authSessionType, credObj } = useSelector((store) => store.auth);
  const { currentUser, isLoading } = useSelector((store) => store.users);
  const { hasAttemptedFetch, isLoading: isStartupLoading } = useSelector(
    (store) => store.startupContents
  );
  const hasLmsSession = authSessionType === "lms" && hasValidJwtSession(credObj);

  useEffect(() => {
    if (!hasLmsSession) return;

    setActiveAuthSessionType("lms");

    if (!currentUser?._id) {
      dispatch(getCurrentUser());
    }

    if (!hasAttemptedFetch && !isStartupLoading) {
      dispatch(fetchStartupContents());
    }
  }, [hasLmsSession, currentUser?._id, hasAttemptedFetch, isStartupLoading, dispatch]);

  if (!hasLmsSession) {
    return <Navigate to="/lms/login" replace state={{ from: location }} />;
  }

  if (!currentUser?._id && isLoading) {
    return <Loading center />;
  }

  if (currentUser?.isEmailVerified === false) {
    return (
      <Navigate
        to={`/lms/verify-email?email=${encodeURIComponent(currentUser?.email || "")}`}
        replace
        state={{ email: currentUser?.email }}
      />
    );
  }

  return children;
};

export default LmsProtectedRoute;
